/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  It contains recoil's atoms files to manage the state value(s)
  atom  : This is an recoil's default library to manage the global state values, This atom is an function and it recieve parameter as object with containing key default values.
  key   : This is an unique key to access this atom function from component.
*/

//import { SignalCellularNull } from '@mui/icons-material'

// System defined variables
import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
import utils from '../../../../utils/utils'

const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // this key is using to store data in storage
  storage: sessionStorage, // configurate which stroage will be used to store the data
})

const toastMessage = atom({
  key: 'toastMessage',
  default: { message: '', status: '' },
})

const showLoading = atom({
  key: 'showLoading',
  default: false,
})

const axiosConfiguration = atom({
  key: 'axiosConfiguration',
  default: null,
})
const msalConfigAtom = atom({
  key: 'msalConfigAtom',
  default: null,
})

// this atom is used to render inactive user screen when domain is invalid
const invalidDomainAtom = atom({
  key: 'invalidDomainAtom',
  default: false,
})

// this will store the currently typed username in sign-page. This will reset when user click on return to login button on any Inactive page.
const currentUsernameAtom = atom({
  key: 'currentUsernameAtom',
  default: '',
})

const gotInitialSessionResponseOfAuthenticationAtom = atom({
  key: 'gotInitialSessionResponseOfAuthenticationAtom',
  default: false,
  effects_UNSTABLE: [persistAtom],
})

const penalityChargeNoticeDetail = atom({
  key: 'penalityChargeNoticeDetail',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

const captchaInputClear = atom({
  key: 'captchaInputClear',
  default: false,
})

const PaymentResponse = atom({
  key: 'PaymentResponse',
  default: '',
})
const NotificationDetails = atom({
  key: 'NotificationDetails',
  default: [],
})
const UserDetails = atom({
  key: 'UserDetails',
  default: '',
})
// persisting this atom to restrict splash screen on page refresh and show the splash screen on initial session
const showSplashScreen = atom({
  key: 'showSplashScreen',
  default: true,
  effects_UNSTABLE: [persistAtom],
})
const prefixSetupData = atom({
  key: 'prefixSetupData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const contractSetupData = atom({
  key: 'contractSetupData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})

const contraventionSetupData = atom({
  key: 'contraventionSetupData',
  default: { mode: 'new', data: {} },
  effects_UNSTABLE: [persistAtom],
})

//This need to be set dynamic once userRole is implemented
const userId = atom({
  key: 'userId',
  default: 1,
})

const selectedCaseDetails = atom({
  key: 'selectedcasedetails',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

const selectCaseDetailNavigationDetails = atom({
  key: 'selectCaseDetailNavigationDetails',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

const selectedContractDetails = atom({
  key: 'selectedcontractdetails',
  default: {},
  effects_UNSTABLE: [persistAtom],
})
const orgSetupData = atom({
  key: 'orgSetupData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const contactAddressData = atom({
  key: 'contactAddressData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const additionalOptionsDisabled = atom({
  key: 'additionalOptionsDisabled',
  default: true,
})

const contactAddressPage = atom({
  key: 'contactAddressPage',
  default: false,
})
const imageData = atom({ key: 'imageData', default: false })

const selectedMenuData = atom({
  key: 'selectmenudata',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

const expandWidgetCountData = atom({
  key: 'expandWidgetCountData',
  default: false,
})
const widgetCountDataAtom = atom({ key: 'widgetCountDataAtom', default: [] })

const selfRenderring = atom({ key: 'selfRenderring', default: false })

const userTokenDetails = atom({
  key: 'userTokenDetails',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const selectOrgNavigationDetails = atom({
  key: 'selectOrgNavigationDetails',
  default: [],
  effects_UNSTABLE: [persistAtom],
})
// contains - considered roles of logged in users (1. when selected any contract - will have that contract's role. 2. When not selected contract will have all distinct assigned roles)
const mappedUserRoles = atom({
  key: 'mappedUserRoles',
  default: [],
  // effects_UNSTABLE: [persistAtom],
})
// contains - roles of logged in user against assigned contract
const assignedContractRoles = atom({
  key: 'assignedContractRoles',
  default: null,
  // effects_UNSTABLE: [persistAtom],
})
// contains - distinct roles of logged in user
const assignedDistinctRoles = atom({
  key: 'assignedDistinctRoles',
  default: [],
  // effects_UNSTABLE: [persistAtom],
})

const faqSetupData = atom({
  key: 'faqSetupData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})

const refreshCaseOverview = atom({
  key: 'refreshCaseOverview',
  default: null,
})

const caseOverviewDataAtom = atom({
  key: 'caseOverviewDataAtom',
  default: {
    totalCasesCount: 0,
    liveCasesCount: 0,
    workflowCount: 0,
    rejectedCount: 0,
    approvalCount: 0,
    stageData: [],
    isPreDebtCleanse: false,
  },
})

const refreshTaskOverview = atom({
  key: 'refreshTaskOverview',
  default: null,
})

const selectedRecId = atom({
  key: 'selectedRecId',
  default: {},
})

const templateData = atom({
  key: 'templateData',
  default: { mode: 'new', data: null, type: 'design' },
  effects_UNSTABLE: [persistAtom],
})
//stores decoded claims of logged in user
const userDetail = atom({
  key: 'userDetail',
  default: null,
})
const triggerPaymentRefresh = atom({
  key: 'triggerPaymentRefresh',
  default: null,
})
const currencyAtom = atom({
  key: 'currencySymbolAtom',
  default: {
    //used globally based on selected contract from homeWidget
    selectedContract: {
      currencyName: '',
      currencySymbol: '',
    },
    //used when search different contract's case through global search
    searchedCase: {
      currencyName: '',
      currencySymbol: '',
    },
  },
  effects_UNSTABLE: [persistAtom],
})
const timezoneAtom = atom({
  key: 'timezoneAtom',
  default: {
    //used globally based on selected contract from homeWidget
    selectedContract: {
      timezoneName: 'GMT Standard Time',
      timezoneId: 'Europe/Belfast', //used for conversion in dayjs
      timezoneOffset: '',
    },
    //used when search different contract's case through global search
    searchedCase: {
      timezoneName: 'GMT Standard Time',
      timezoneId: 'Europe/Belfast', //used for conversion in dayjs
      timezoneOffset: '',
    },
    default: {
      timezoneName: 'GMT Standard Time',
      timezoneId: 'Europe/Belfast', //used for conversion in dayjs
      timezoneOffset: 'GMT+00',
    },
  },
  effects_UNSTABLE: [persistAtom],
})
const selectedContactAddress = atom({
  key: 'selectedContactAddress',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

const fetchCurrentApprovalList = atom({
  key: 'fetchCurrentApprovalList',
  default: false,
})

const showLoadingText = atom({
  key: 'showLoadingText',
  default: { isShowLoadingText: false },
})
const tribunalAppealData = atom({
  key: 'tribunalAppealData',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const madeChanges = atom({
  key: 'madeChanges',
  default: false,
})
const invalidatePcnData = atom({
  key: 'invalidatePcnData',
  default: false,
})
const refreshManualDiscountGrid = atom({
  key: 'refreshManualDiscountGrid',
  default: true,
})
const refreshManageCostGrid = atom({
  key: 'refreshManageCostGrid',
  default: true,
})

const locationData = atom({
  key: 'locationData',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

const bailiffData = atom({
  key: 'bailiffData',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const purgeData = atom({
  key: 'purgeData',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
/* atom used to update when token expired at runtime based on api-response(unauthorized) */
const runtimeTokenExpiredAtom = atom({
  key: 'runtimeTokenExpiredAtom',
  default: false,
  effects_UNSTABLE: [persistAtom],
})
const LoaderOnIndexJsAtom = atom({ key: 'LoaderOnIndexJsAtom', default: true })

// made this atom stable due to maintain this inactive(for TokenExpire screen) after refresh also
const userWentInactiveAtom = atom({
  key: 'userWentInactiveAtom',
  default: false,
  effects_UNSTABLE: [persistAtom],
})
// wont this atom anymore as we removed auto-logout functionality from BO application. Only Refresh token will be done BO UI.

const errorCodes = atom({
  key: 'errorCodes',
  default: { errorCode: '', showErrorPage: false },
})

const loggingOutAtom = atom({ key: 'loggingOutAtom', default: false })

const contactAddressKeeper = atom({
  key: 'contactAddressId',
  default: null,
})

const representationReviewParams = atom({
  key: 'representationReviewParams',
  default: {},
})

// used to store the display/hide the search list page
const showSearchListPage = atom({
  key: 'showSearchListPage',
  default: false,
  effects_UNSTABLE: [persistAtom],
})

// used for handling the applied field's list and values in search page
const searchListFormValues = atom({
  key: 'searchListFormValues',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

// Used for handling the reset and apply button values in search page
const buttonResetValues = atom({
  key: 'buttonResetValues',
  default: { resetButton: false, applyButton: false },
  effects_UNSTABLE: [persistAtom],
})

// Used for store the local selected value and used to display the org and contract name
const brandingConfigurationValue = atom({
  key: 'brandingConfigurationValue',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

const integrationServiceDataAtom = atom({
  key: 'integrationServiceDataAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const selectLinkedCaseDetails = atom({
  //selectLinkedCaseDetails-> this atom wll not used in future as we going to use queryParams for case id -> linked case will also follow browser history.  key: 'selectLinkedCaseDetails',
  key: 'selectLinkedCaseDetails',
  default: [],
  effects_UNSTABLE: [persistAtom],
})
const activeLinkedCaseNumberAtom = atom({
  key: 'activeLinkedCaseNumberAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const activeSearchListCaseIndexAtom = atom({
  key: 'activeSearchListCaseIndexAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

//used to search list grid data because when main page next and previous case prevision
const searchListFormGridData = atom({
  key: 'searchListFormGridData',
  default: {},
  effects_UNSTABLE: [persistAtom],
})
const isSidebarExpanded = atom({
  key: 'isSidebarExpanded',
  default: true,
  effects_UNSTABLE: [persistAtom],
})
const pcnNumberReservationData = atom({
  key: 'pcnNumberReservationData',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

const refreshReallocationGrid = atom({
  key: 'refreshReallocationGrid',
  default: true,
})
const contractSettingData = atom({
  key: 'contractSettingData',
  default: {},
  effects_UNSTABLE: [persistAtom],
})
const geoFencingSetUpData = atom({
  key: 'geoFencingSetUpData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const brandingStateValues = atom({
  key: 'brandingStateValues',
  default: { brandingRecId: null, brandingType: '', selectedBrandingData: {} },
  effects_UNSTABLE: [persistAtom],
})
const prioritySettingDataFinal = atom({
  key: 'prioritySettingDataFinal',
  default: {},
})
const priorityFieldList = atom({
  key: 'priorityFieldList',
  default: [],
})
const priorityRuleGetData = atom({
  key: 'priorityRuleGetData',
  default: {},
})
const ceoTaskDetails = atom({
  key: 'ceoTaskDetails',
  default: {},
  effects_UNSTABLE: [persistAtom],
})
const selectedJobDetails = atom({
  key: 'selectedJobDetails',
  default: {},
  effects_UNSTABLE: [persistAtom],
})
const jobStepper = atom({
  key: 'jobStepper',
  default: [],
  effects_UNSTABLE: [persistAtom],
})
const crContactAddressData = atom({
  key: 'crContactAddressData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const poundContactAddressData = atom({
  key: 'poundContactAddressData',
  default: { mode: 'new', data: null },
  effects_UNSTABLE: [persistAtom],
})
const poundDetailsAtom = atom({
  key: 'poundDetailsAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const briefingMessagePreviewAtom = atom({
  key: 'briefingMessagePreviewAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const allContractDetails = atom({
  key: 'allContractDetails',
  default: [],
  effects_UNSTABLE: [persistAtom],
})
const reportFavouriteData = atom({
  key: 'reportFavouriteData',
  default: {},
})
const fetchReportFavourites = atom({
  key: 'fetchReportFavourites',
  default: false,
})
const reportFavouritesRefreshStatusAtom = atom({
  key: 'reportFavouritesRefreshStatusAtom',
  default: 'completed', // completed - refresh is completed and ready to start new. start - call favourites api only if it is in start state. on-hold - done for monkey testing (not to get listOfFavourites untill add/remove to favoutites )
})
const selectedContractList = atom({
  key: 'selectedContractList',
  default: {
    contractId: '0',
    contractName: 'All',
  },
})

const refreshRecordPayGridDataAtom = atom({
  key: 'refreshRecordPayGridDataAtom',
  default: false,
})
const accessibleUserForClampAndRemoval = atom({
  key: 'accessibleUserForClampAndRemoval',
  default: false,
  effects_UNSTABLE: [persistAtom],
})

const workflowTasks = atom({
  key: 'workflowTasks',
  default: [],
})

const lastSelectedTab = atom({
  key: 'lastSelectedTab',
  default: null,
})
const airaSendCorrespondenceValues = atom({
  key: 'airaSendCorrespondenceValues',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

const lastPathName = atom({
  key: 'lastPathName',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

const caseOverviewTabSelectedIndexAtom = atom({
  key: 'watchCasesTabClickAtom',
  default: 0,
  effects_UNSTABLE: [persistAtom],
})

const taskOverviewData = atom({
  key: 'taskOverviewData',
  default: [],
})

const taskOverviewSelectedContractView = atom({
  key: 'taskOverviewSelectedContractView',
  default: 'current',
})

const expandedItemsState = atom({
  key: 'expandedItemsState',
  default: [],
})

const airaLayoutChanges = atom({
  key: 'airaLayoutChanges',
  default: false,
})

const jobTabIndex = atom({
  key: 'jobTabIndex',
  default: 0,
})
const poundTabIndex = atom({
  key: 'poundTabIndex',
  default: 0,
})
const searchingJobIdData = atom({
  key: 'searchingJobIdData',
  default: [],
})
const preCaseDetailsAtom = atom({
  key: 'preCaseDetailsAtom',
  default: null,
})
const refreshAttachmentOnPreCaseDetailsTabAtom = atom({
  key: 'refreshAttachmentOnPreCaseDetailsTabAtom',
  default: false,
})
const isPaymentEnabled = atom({
  key: 'isPaymentEnabled',
  default: false,
})
const menuItemDatasourceAtom = atom({
  key: 'menuItemDatasourceAtom',
  default: utils.menuItemDatasourceBase,
})
const hideTitleBarAtom = atom({
  key: 'hideTitleBarAtom',
  default: false,
})
const reportConfigurationData = atom({
  key: 'reportConfigurationData',
  default: [],
})
const CaseStatusDetail = atom({
  key: 'CaseStatusDetail',
  default: '',
})
const widgetState = atom({
  key: 'widgetState',
  default: {
    // Default landing after login should be Contracts tab
    type: utils?.widgetTypes?.contract,
    data: null,
  },
  effects_UNSTABLE: [persistAtom],
}) //need to find which widgets are marked as favourites need the type
const boManagerLocationZoneEnabled = atom({
  key: 'boManagerLocationZoneEnabled',
  default: false,
})
const boManagerBriefingAccessEnabled = atom({
  key: 'boManagerBriefingAccessEnabled',
  default: false,
})
const observationDetailsAtom = atom({
  key: 'observationDetailsAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
})
const myWorkflowSummarizationDialog = atom({
  key: 'myWorkflowSummarizationDialog',
  default: false,
})
const onHoldSummarizationDialog = atom({
  key: 'onHoldSummarizationDialog',
  default: false,
})
const pcnPageSummarizationDialog = atom({
  key: 'pcnPageSummarizationDialog',
  default: false,
})
const caseNumber = atom({
  key: 'caseNumber',
  default: '',
})
const getInitialTheme = () => {
  try {
    const cached = localStorage.getItem('bo-theme')
    if (cached === 'dark' || cached === 'light') return cached
  } catch (e) {}
  try {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    )
      return 'dark'
  } catch (e) {}
  return 'light'
}

const themeModeAtom = atom({
  key: 'themeModeAtom',
  default: getInitialTheme(),
})

export {
  toastMessage,
  showLoading,
  axiosConfiguration,
  msalConfigAtom,
  invalidDomainAtom,
  currentUsernameAtom,
  gotInitialSessionResponseOfAuthenticationAtom,
  penalityChargeNoticeDetail,
  captchaInputClear,
  PaymentResponse,
  NotificationDetails,
  UserDetails,
  showSplashScreen,
  selectedCaseDetails,
  selectedContractDetails,
  prefixSetupData,
  contractSetupData,
  userId,
  orgSetupData,
  contactAddressData,
  imageData,
  additionalOptionsDisabled,
  selectedMenuData,
  contactAddressPage,
  selfRenderring,
  expandWidgetCountData,
  widgetCountDataAtom,
  contraventionSetupData,
  userTokenDetails,
  selectOrgNavigationDetails,
  selectCaseDetailNavigationDetails,
  mappedUserRoles,
  assignedContractRoles,
  assignedDistinctRoles,
  faqSetupData,
  refreshCaseOverview,
  caseOverviewDataAtom,
  refreshTaskOverview,
  templateData,
  selectedRecId,
  userDetail,
  triggerPaymentRefresh,
  currencyAtom,
  timezoneAtom,
  selectedContactAddress,
  showLoadingText,
  fetchCurrentApprovalList,
  tribunalAppealData,
  madeChanges,
  invalidatePcnData,
  refreshManualDiscountGrid,
  refreshManageCostGrid,
  locationData,
  bailiffData,
  purgeData,
  runtimeTokenExpiredAtom,
  LoaderOnIndexJsAtom,
  userWentInactiveAtom,
  errorCodes,
  loggingOutAtom,
  contactAddressKeeper,
  representationReviewParams,
  showSearchListPage,
  searchListFormValues,
  buttonResetValues,
  brandingConfigurationValue,
  integrationServiceDataAtom,
  selectLinkedCaseDetails,
  activeLinkedCaseNumberAtom,
  activeSearchListCaseIndexAtom,
  searchListFormGridData,
  isSidebarExpanded,
  refreshReallocationGrid,
  pcnNumberReservationData,
  contractSettingData,
  geoFencingSetUpData,
  brandingStateValues,
  prioritySettingDataFinal,
  priorityFieldList,
  priorityRuleGetData,
  ceoTaskDetails,
  selectedJobDetails,
  crContactAddressData,
  jobStepper,
  poundDetailsAtom,
  poundContactAddressData,
  allContractDetails,
  briefingMessagePreviewAtom,
  selectedContractList,
  reportFavouriteData,
  fetchReportFavourites,
  reportFavouritesRefreshStatusAtom,
  refreshRecordPayGridDataAtom,
  accessibleUserForClampAndRemoval,
  workflowTasks,
  lastSelectedTab,
  airaSendCorrespondenceValues,
  lastPathName,
  caseOverviewTabSelectedIndexAtom,
  taskOverviewData,
  taskOverviewSelectedContractView,
  expandedItemsState,
  airaLayoutChanges,
  jobTabIndex,
  poundTabIndex,
  searchingJobIdData,
  preCaseDetailsAtom,
  refreshAttachmentOnPreCaseDetailsTabAtom,
  isPaymentEnabled,
  menuItemDatasourceAtom,
  hideTitleBarAtom,
  reportConfigurationData,
  CaseStatusDetail,
  widgetState,
  boManagerLocationZoneEnabled,
  boManagerBriefingAccessEnabled,
  observationDetailsAtom,
  myWorkflowSummarizationDialog,
  caseNumber,
  onHoldSummarizationDialog,
  pcnPageSummarizationDialog,
  themeModeAtom,
}
